import React, { Suspense, lazy } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  RouteObject,
} from "react-router-dom";
import { ROUTES } from "./utils/constants";
import { authLoader } from "./loaders/auth/authLoader";
import { loginLoader } from "./loaders/auth/loginLoader";
import { Loader } from "./utils/Spinners"; // Import the Loader component
import FunctionalityBasedRoute from "./utils/FunctionalityBasedRoute";
import MobileClaimSuccessContainer from "./containers/patient/MobileClaimSuccessContainer";
import PatientListContainer from "./containers/patient/PatientListContainer";
import HomeScreenContainer from "./containers/patient/HomeScreenContainer";
import { ConfigProvider } from "antd";
import RegistrationContainerTabs from "./containers/patient/RegistrationContainer";
import PatientRegistration from "./containers/patient/PatientRegistrationContainer";
import PatientRegistrationContainer from "./containers/patient/PatientRegistrationContainer";

const AuthContainer = lazy(() => import("./containers/auth/AuthContainer"));

const AddPatientContainer = lazy(
  () => import("./containers/patient/AddPatientContainer"),
);

const LandingPageContainer = lazy(
  () => import("./containers/landing-page/LandingPageContainer"),
);

const InstallPWA = lazy(() => import("./components/pwa/InstallPWA"));
const UpdatePrompt = lazy(() => import("./components/pwa/UpdatePrompt"));

const routes: RouteObject[] = [
  {
    path: ROUTES.LANDING,
    loader: loginLoader,
    element: (
      <Suspense fallback={<Loader />}>
        <AuthContainer />
      </Suspense>
    ),
  },
  {
    path: ROUTES.LOGIN,
    loader: loginLoader,
    element: (
      <Suspense fallback={<Loader />}>
        <AuthContainer />
      </Suspense>
    ),
  },
  {
    path: ROUTES.LANDING_PAGE,
    element: (
      <Suspense fallback={<Loader />}>
        <LandingPageContainer />
      </Suspense>
    ),
    loader: authLoader,
    children: [
      {
        path: ROUTES.ADD_PATIENT,
        element: (
          <FunctionalityBasedRoute requiredFunctionality="patientAdd">
            <Suspense fallback={<Loader />}>
              {/* <AddPatientContainer /> */}
              <ConfigProvider
                theme={{
                  token: {
                    fontSize: 10,
                  },
                }}
              >
                <RegistrationContainerTabs />
              </ConfigProvider>
            </Suspense>
          </FunctionalityBasedRoute>
        ),
      },
      {
        path: `${ROUTES.CLAIM_ID_GENERATION}/:visitId`,
        element: (
          <FunctionalityBasedRoute requiredFunctionality="patientAdd">
            <Suspense fallback={<Loader />}>
              <MobileClaimSuccessContainer />
            </Suspense>
          </FunctionalityBasedRoute>
        ),
      },
      {
        path: `${ROUTES.PATIENT_LIST}`,
        element: (
          <FunctionalityBasedRoute requiredFunctionality="patientAdd">
            <Suspense fallback={<Loader />}>
              <PatientListContainer />
            </Suspense>
          </FunctionalityBasedRoute>
        ),
      },
      {
        path: `${ROUTES.PATIENT_LIST}/:stage`,
        element: (
          <FunctionalityBasedRoute requiredFunctionality="patientAdd">
            <Suspense fallback={<Loader />}>
              <PatientListContainer />
            </Suspense>
          </FunctionalityBasedRoute>
        ),
      },
      {
        path: `${ROUTES.PATIENT_REGISTRATION}/:visitId`,
        element: (
          <FunctionalityBasedRoute requiredFunctionality="patientAdd">
            <Suspense fallback={<Loader />}>
              <ConfigProvider
                theme={{
                  token: {
                    fontSize: 12,
                  },
                }}
              >
                <PatientRegistrationContainer />
              </ConfigProvider>
            </Suspense>
          </FunctionalityBasedRoute>
        ),
      },
      {
        path: `${ROUTES.HOME_SCREEN}`,
        element: (
          <FunctionalityBasedRoute requiredFunctionality="patientAdd">
            <Suspense fallback={<Loader />}>
              <ConfigProvider
                theme={{
                  token: {
                    fontSize: 10,
                  },
                }}
              >
                <HomeScreenContainer />
              </ConfigProvider>
            </Suspense>
          </FunctionalityBasedRoute>
        ),
      },
    ],
  },
];

const router = createBrowserRouter(routes);

function App() {
  return (
    <div className="scale-container">
      <div className="scaled-content">
        {/* Install PWA banner */}
        <Suspense fallback={null}>
          <InstallPWA />
        </Suspense>
        {/* Service worker update prompt */}
        <Suspense fallback={null}>
          <UpdatePrompt />
        </Suspense>
        <Suspense fallback={<Loader />}>
          <RouterProvider router={router} />
        </Suspense>
      </div>
    </div>
  );
}

export default App;
